import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";

export default function Carteira(props) {
  const [carteiraId] = useState(Number(props.match.params.id));
  const history = props.history;
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (carteiraId > 0) {
      carregarCarteira();
    }
  }, []);

  const carregarCarteira = () => {
    setCarregando(true);

    api
      .get("carteiras/carregar", { id: carteiraId })
      .then((res) => {
        setDados(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar carteira");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    setDados(params);

    if (Number(params.metaTreinamentos)) {
      if (
        Number(params.metaTreinamentos) < 1 ||
        Number(params.metaTreinamentos) > 100
      ) {
        return notification(
          "warning",
          "O valor para a meta de treinamentos deve estar entre 1 e 100"
        );
      }
    }

    if (carteiraId === 0) {
      api
        .put("carteiras/inserir", params)
        .then((res) => {
          notification("success", "Carteira inserida!");
          setDados({});
          history.push(`/app/carteira`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      params.id = carteiraId;
      api
        .post("carteiras/editar", params)
        .then((res) => {
          notification("success", "Carteira editada!");
          setDados({});
          history.push(`/app/carteira`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fCarteira = {
    title: "Carteira",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: dados.nome,
        space: 6,
      },
      metaTreinamentos: {
        label: "Meta de treinamentos (%)",
        type: "number",
        value: dados.metaTreinamentos,
        space: 4,
      },
      ativa: {
        label: "Ativa",
        type: "check",
        value: carteiraId > 0 ? dados.ativa : true,
        space: 2,
      },
    },

    submit: {
      label: "salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fCarteira} />}
    </div>
  );
}
